import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const SocialLinksThunk = createAsyncThunk(
	"SocialLinks/SocialLinksThunk",
	async (_, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`api/social_links`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
